"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var react_socks_1 = __importDefault(require("react-socks"));
var models_1 = require("./models");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var Row_1 = __importDefault(require("./styledComponents/Row"));
var Column_1 = __importDefault(require("./styledComponents/Column"));
var Component_1 = __importDefault(require("./styledComponents/Component"));
var Grid_meta_1 = require("./Grid.meta");
var mobx_1 = require("mobx");
var Query = ksys_app_template_1.query.Query;
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Grid_meta_1.GRID_CATEGORY_KEY;
        _this.componentKey = Grid_meta_1.GRID_COMPONENT_KEY;
        _this.getUiId = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return params.filter(function (param) { return param !== undefined; }).join('_');
        };
        _this.loadUiIds = function (grid, parentUiId) {
            if (grid) {
                if (!grid.uiId) {
                    grid.uiId = _this.getUiId(parentUiId, ksys_app_template_1.utils.guid.generateGuid());
                }
                grid.parentUiId = parentUiId;
                if (grid.rows) {
                    grid.rows.forEach(function (row, rowIndex) {
                        if (!row.uiId) {
                            row.uiId = _this.getUiId(grid.uiId, "row-" + rowIndex);
                        }
                        row.parentUiId = grid.uiId;
                        if (row.columns) {
                            row.columns.forEach(function (column, columnIndex) {
                                if (!column.uiId) {
                                    column.uiId = _this.getUiId(row.uiId, "column-" + columnIndex);
                                }
                                column.parentUiId = row.uiId;
                                if (column.components) {
                                    column.components.forEach(function (component, componentIndex) {
                                        if (!component.uiId) {
                                            component.uiId = _this.getUiId(column.uiId, "component-" + componentIndex);
                                        }
                                        component.parentUiId = column.uiId;
                                        if (component.grid) {
                                            _this.loadUiIds(component.grid, component.uiId);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        };
        _this.mergeComponentPropsAndQueries = function (component, responseContext) {
            var queryStore = _this.props.queryStore;
            if (component) {
                var props = component.props, queries = component.queries;
                if (queryStore) {
                    var executionOptions = queryStore.executionOptions;
                    if (responseContext) {
                        executionOptions = ksys_app_template_1.utils.object.deepMergeObjects({ arrayMergeStrategy: 'DeepMerge' }, executionOptions, { responseContext: responseContext });
                    }
                    var queryResults = queries ? Query.convertQueryMime(queries, executionOptions) : {};
                    var response = ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepMerge' }, props || {}, queryResults);
                    return response;
                }
                return props;
            }
        };
        _this.getKey = function (prefix, index, repetitionIndex, name) {
            if (repetitionIndex === void 0) { repetitionIndex = 0; }
            if (name === void 0) { name = 'NO_NAME'; }
            return prefix + "_" + index + "_" + repetitionIndex + "_" + name;
        };
        _this.getElementRepetitionParams = function (element, elementType, repetition, parentRepetitions) {
            if (parentRepetitions === void 0) { parentRepetitions = []; }
            var repetitionsForChildren = __spreadArrays(parentRepetitions);
            if (element.repetitions) {
                repetitionsForChildren.push.apply(repetitionsForChildren, element.repetitions);
            }
            repetitionsForChildren.push(repetition);
            var repetitionProps = _this.getRepetitionProps(elementType, repetitionsForChildren);
            return {
                repetitionsForChildren: repetitionsForChildren,
                repetitionProps: repetitionProps,
            };
        };
        _this.renderGrid = function (grid, gridIndex, parentRepetitions) {
            if (parentRepetitions === void 0) { parentRepetitions = []; }
            var _a = grid.rows, rows = _a === void 0 ? [] : _a, gridStyle = grid.style, uiId = grid.uiId, gridName = grid.name;
            var repetitions = _this.getRepetitions(grid);
            var fragmentKey = _this.getKey('grid', gridIndex, -1, gridName);
            return (react_1.default.createElement(react_1.Fragment, { key: fragmentKey }, repetitions.map(function (repetition, repetitionIndex) {
                var gridKey = _this.getKey('grid', gridIndex, repetitionIndex, gridName);
                var _a = _this.getElementRepetitionParams(grid, models_1.GridElement.grid, repetition, parentRepetitions), repetitionProps = _a.repetitionProps, repetitionsForChildren = _a.repetitionsForChildren;
                return (react_1.default.createElement(Wrapper_1.default, __assign({ "data-ui-id": uiId }, repetitionProps, { key: gridKey, componentStyle: gridStyle }), rows.map(function (row, rowIndex) {
                    return _this.renderRow(row, rowIndex, repetitionsForChildren);
                })));
            })));
        };
        _this.renderRow = function (row, rowIndex, parentRepetitions) {
            if (parentRepetitions === void 0) { parentRepetitions = []; }
            var rowName = row.name, rowStyle = row.style, _a = row.columns, columns = _a === void 0 ? [] : _a, uiId = row.uiId;
            var repetitions = _this.getRepetitions(row);
            var fragmentKey = _this.getKey('row', rowIndex, -1, rowName);
            return (react_1.default.createElement(react_1.Fragment, { key: fragmentKey }, repetitions.map(function (repetition, repetitionIndex) {
                var rowKey = _this.getKey('row', rowIndex, repetitionIndex, rowName);
                var _a = _this.getElementRepetitionParams(row, models_1.GridElement.row, repetition, parentRepetitions), repetitionProps = _a.repetitionProps, repetitionsForChildren = _a.repetitionsForChildren;
                return (react_1.default.createElement(Row_1.default, __assign({ "data-ui-id": uiId }, repetitionProps, { key: rowKey, componentStyle: rowStyle }), columns.map(function (column, columnIndex) {
                    return _this.renderColumn(column, columnIndex, repetitionsForChildren);
                })));
            })));
        };
        _this.renderColumn = function (column, columnIndex, parentRepetitions) {
            if (parentRepetitions === void 0) { parentRepetitions = []; }
            var columnName = column.name, columnStyle = column.style, _a = column.components, columnComponents = _a === void 0 ? [] : _a, uiId = column.uiId;
            var repetitions = _this.getRepetitions(column);
            var fragmentKey = _this.getKey('column', columnIndex, -1, columnName);
            return (react_1.default.createElement(react_1.Fragment, { key: fragmentKey }, repetitions.map(function (repetition, repetitionIndex) {
                var columnKey = _this.getKey('column', columnIndex, repetitionIndex, columnName);
                var _a = _this.getElementRepetitionParams(column, models_1.GridElement.column, repetition, parentRepetitions), repetitionProps = _a.repetitionProps, repetitionsForChildren = _a.repetitionsForChildren;
                return (react_1.default.createElement(Column_1.default, __assign({ "data-ui-id": uiId }, repetitionProps, { key: columnKey, componentStyle: columnStyle }), columnComponents.map(function (component, componentIndex) {
                    return _this.renderComponent(component, componentIndex, repetitionsForChildren);
                })));
            })));
        };
        _this.renderComponent = function (gridComponent, componentIndex, parentRepetitions) {
            if (parentRepetitions === void 0) { parentRepetitions = []; }
            var _a = _this.props, components = _a.components, queryStore = _a.queryStore, noPropFlatten = _a.noPropFlatten;
            var configurationComponents = (_this.configuration || {}).components;
            var allComponents = __assign(__assign({}, (configurationComponents || {})), (components || {}));
            var componentName = gridComponent.name, componentStyle = gridComponent.style, childGrid = gridComponent.grid, key = gridComponent.key, childrenComponents = gridComponent.children, uiId = gridComponent.uiId;
            var repetitions = _this.getRepetitions(gridComponent);
            var fragmentKey = _this.getKey('component', componentIndex, -1, componentName);
            return (react_1.default.createElement(react_1.Fragment, { key: fragmentKey }, repetitions.map(function (repetition, repetitionIndex) {
                var componentKey = _this.getKey('component', componentIndex, repetitionIndex, componentName);
                var _a = _this.getElementRepetitionParams(gridComponent, models_1.GridElement.component, repetition, parentRepetitions), repetitionProps = _a.repetitionProps, repetitionsForChildren = _a.repetitionsForChildren;
                var child = null;
                if (key) {
                    var gridComponentReference = allComponents[key];
                    if (gridComponentReference) {
                        var AppComponent = gridComponentReference.component, hide = gridComponentReference.hide;
                        if (!hide && AppComponent) {
                            var componentProps = _this.getComponentProps(gridComponent, gridComponentReference, repetitionProps);
                            if (componentProps) {
                                var _b = componentProps.props, props = _b === void 0 ? {} : _b, _c = componentProps.referenceProps, referenceProps = _c === void 0 ? {} : _c;
                                var children = null;
                                if (childrenComponents && mobx_1.isArrayLike(childrenComponents)) {
                                    children = childrenComponents.map(function (child, childIndex) {
                                        return _this.renderComponent(child, childIndex, repetitionsForChildren);
                                    });
                                }
                                child = (react_1.default.createElement(AppComponent, __assign({ "data-ui-id": uiId }, repetitionProps, referenceProps, props), children));
                            }
                        }
                    }
                }
                else if (childGrid) {
                    child = _this.renderGrid(childGrid, 0, repetitionsForChildren);
                    // <StyledGrid data-ui-id={uiId} grid={childGrid} components={components} queryStore={queryStore} />;
                }
                return (react_1.default.createElement(Component_1.default, { "data-ui-id": uiId, key: componentKey, componentStyle: componentStyle }, child));
            })));
        };
        _this.getRepetitions = function (element) {
            var repeater = element.repeater;
            var repetitions = [];
            if (!repeater) {
                // If there is no repeater we load a single value in
                repetitions.push({});
            }
            else {
                var _a = repeater.inputs, inputs = _a === void 0 ? [] : _a;
                inputs.forEach(function (input) {
                    var values = _this.convertToArray(_this.getRepeaterInputValues(input));
                    if (values) {
                        var hasExistingRepetitions_1 = repetitions.length > 0;
                        var newRepetitions_1 = [];
                        values.forEach(function (value) {
                            if (!hasExistingRepetitions_1) {
                                newRepetitions_1.push(_this.loadRepetition({}, repeater, input, value));
                            }
                            else {
                                repetitions.forEach(function (repetition) {
                                    newRepetitions_1.push(_this.loadRepetition(repetition, repeater, input, value));
                                });
                            }
                        });
                        repetitions = newRepetitions_1;
                    }
                });
            }
            return repetitions;
        };
        _this.convertToArray = function (value) {
            if (typeof value !== 'undefined' && !mobx_1.isArrayLike(value)) {
                return [value];
            }
            return value;
        };
        _this.loadRepetition = function (repetition, repeater, input, value) {
            var key = input.key;
            if (!repetition.inputs) {
                repetition.inputs = {};
            }
            var inputs = repetition.inputs;
            if (key) {
                inputs[key] = {
                    key: key,
                    value: value,
                    input: input,
                    repeater: repeater,
                };
            }
            return repetition;
        };
        _this.getRepeaterInputValues = function (input) {
            var queryStore = _this.props.queryStore;
            var valuesQuery = input.valuesQuery;
            if (queryStore && valuesQuery) {
                var query_1 = new Query(valuesQuery);
                return query_1.execute(queryStore.executionOptions);
            }
            return undefined;
        };
        _this.getRepetitionProps = function (elementType, repetitions) {
            if (repetitions === void 0) { repetitions = []; }
            var props = {};
            repetitions.forEach(function (repetition) {
                var inputs = repetition.inputs;
                if (inputs) {
                    var inputKeys = Object.keys(inputs);
                    inputKeys.forEach(function (key) {
                        var repetitionInput = inputs[key];
                        var value = repetitionInput.value, repeater = repetitionInput.repeater;
                        if (!repeater || !repeater.targets || repeater.targets.includes(elementType)) {
                            props[key] = value;
                        }
                    });
                }
            });
            return props;
        };
        _this.getComponentProps = _this.getComponentProps.bind(_this);
        if (props.loadUiIds) {
            _this.loadUiIds(props.grid);
        }
        return _this;
    }
    Grid.prototype.getComponentProps = function (component, componentReference, responseContext) {
        if (component && componentReference) {
            var referenceProps = this.mergeComponentPropsAndQueries(componentReference, responseContext);
            var props = this.mergeComponentPropsAndQueries(component, responseContext);
            return { props: props, referenceProps: referenceProps };
        }
    };
    Grid.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        var breakpoints = this.breakpoints;
        return (react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
            var props = breakpoint.props;
            if (props) {
                var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);
                var grid = props.grid;
                if (!grid) {
                    return null;
                }
                return (react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps),
                    _this.renderGrid(grid, 0),
                    children));
            }
        })));
    };
    Grid = __decorate([
        mobx_react_1.observer
    ], Grid);
    return Grid;
}(shared_1.ResponsiveComponentBase));
exports.Grid = Grid;
var StyledGrid = shared_1.InjectedStyledComponent(Grid, Grid_meta_1.GRID_CATEGORY_KEY, Grid_meta_1.GRID_COMPONENT_KEY);
exports.default = StyledGrid;
